import React, { useState } from 'react';
import './App.less';
import { useInitializeConfiguration } from './Utils/Hooks/useInitializeConfiguration'
import LoadingFullScreen from './components/loading/LoadingFullScreen'
//Hooks
import { useTranslation } from 'react-i18next'

import AppRouter from './components/pages/AppRouter'
import { Provider } from 'react-redux';
import store from './library/src/redux/store'

export default function App() {

  const [isLoading, setIsLoading] = useState(true);
  useInitializeConfiguration(setIsLoading);
  const { t } = useTranslation('utils') 

  if(isLoading) {
    return (
      <LoadingFullScreen text={t("utils:retrievingData")} />
    )
  }

  return (
    <Provider store={store}>
      <AppRouter />
    </Provider>
  );
}